function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { map } from "lodash";
import { nanoid } from "nanoid";
import Fuse from "fuse.js";
import { max } from "lodash";
import { editCellHelper } from "../DataTable";

var getSchema = function getSchema(data) {
  return {
    fields: map(data[0], function (val, path) {
      return {
        path: path,
        type: "string"
      };
    }),
    userData: map(data, function (d) {
      if (!d.id) {
        return _extends({}, d, {
          id: nanoid()
        });
      }

      return d;
    })
  };
};

export default function tryToMatchSchemas(_ref) {
  var incomingData = _ref.incomingData,
      validateAgainstSchema = _ref.validateAgainstSchema;
  var userSchema = getSchema(incomingData);

  var _matchSchemas = matchSchemas({
    userSchema: userSchema,
    officialSchema: validateAgainstSchema
  }),
      searchResults = _matchSchemas.searchResults,
      csvValidationIssue = _matchSchemas.csvValidationIssue;

  if (!csvValidationIssue) {
    return {
      userSchema: userSchema,
      csvValidationIssue: csvValidationIssue
    };
  }

  var incomingHeadersToScores = {};
  searchResults.forEach(function (r) {
    r.matches.forEach(function (match) {
      incomingHeadersToScores[match.item.path] = incomingHeadersToScores[match.item.path] || [];
      incomingHeadersToScores[match.item.path].push(match.score);
    });
  });
  searchResults.forEach(function (r) {
    for (var _iterator = _createForOfIteratorHelperLoose(r.matches), _step; !(_step = _iterator()).done;) {
      var match = _step.value;
      if (!incomingHeadersToScores[match.item.path]) continue;
      var maxScore = max(incomingHeadersToScores[match.item.path]);

      if (maxScore === match.score) {
        r.topMatch = match.item.path;
        r.matches.forEach(function (match) {
          if (!incomingHeadersToScores[match.item.path]) return;
          var arr = incomingHeadersToScores[match.item.path];
          arr.splice(arr.indexOf(match.score), 1);
        });
        delete incomingHeadersToScores[match.item.path];
        break;
      }
    }
  });
  var initialMatchedHeaders = {};
  searchResults.forEach(function (r, i) {
    if (r.topMatch) {
      initialMatchedHeaders[i] = r.topMatch;
    }
  });
  return {
    csvValidationIssue: csvValidationIssue,
    initialMatchedHeaders: initialMatchedHeaders,
    userSchema: userSchema,
    searchResults: searchResults
  };
}

function matchSchemas(_ref2) {
  var userSchema = _ref2.userSchema,
      officialSchema = _ref2.officialSchema;
  var options = {
    includeScore: true,
    keys: ["path", "displayName"]
  };
  var csvValidationIssue = false;
  var fuse = new Fuse(userSchema.fields, options);
  officialSchema.fields.forEach(function (h) {
    var hasMatch = false; //run fuse search for results

    var result = fuse.search(h.path) || []; //if there are any exact matches, push them onto the results array

    userSchema.fields.forEach(function (uh, i) {
      if (uh.path.toLowerCase().replace(/ /g, "") === h.path.toLowerCase().replace(/ /g, "")) {
        result = result.filter(function (_ref3) {
          var path = _ref3.path;
          return path === uh.path;
        }); //add a fake perfect match result to make sure we get the match

        result.unshift({
          item: {
            path: uh.path,
            type: h.type
          },
          refIndex: i,
          score: 0
        });
        hasMatch = true;
      }
    });
    h.matches = result;
    if (!hasMatch) csvValidationIssue = "It looks like some of the headers in your uploaded file do not match the expected headers. Please look over and correct any issues with the mappings below.";
  });
  var editableFields = officialSchema.fields.filter(function (f) {
    return !f.isNotEditable;
  });
  var hasErr = !csvValidationIssue && userSchema.userData.some(function (e) {
    return editableFields.some(function (columnSchema) {
      //mutative
      var _editCellHelper = editCellHelper({
        entity: e,
        columnSchema: columnSchema,
        newVal: e[columnSchema.matches[0].item.path]
      }),
          error = _editCellHelper.error;

      if (error) {
        return true;
      }

      return false;
    });
  });

  if (hasErr) {
    csvValidationIssue = "Some of the data doesn't look quite right. Do these header mappings look correct?";
  }

  if (!csvValidationIssue) {
    //all the headers match up as does the actual data
    return {
      csvValidationIssue: csvValidationIssue
    };
  }

  return {
    searchResults: officialSchema.fields,
    csvValidationIssue: csvValidationIssue
  };
}